{
  "moreActions": "更多操作",
  "unavailable": "不可用，展开以查看详细信息"
}
